import styles from './TableTitle.module.css';

/**
 * Table title component with title on the left and actions on the right
 * @param {object} props
 * @param {string} props.title - Title text to display
 * @param {React.ReactNode} [props.children] - Action buttons or other content
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.subTitle] - Subtitle text to display
 * @param {boolean} [props.hideTitle=false] - Hide the title and subtitle, keeping only the actions
 * @returns {React.ReactNode}
 */
function TableTitle({
  title, subTitle, children, className = '', hideTitle = false,
}) {
  return (
    <div id="table-title" className={`${styles['table-title']} ${className}`}>
      {!hideTitle ? (
        <h2 className={styles['table-title-text']}>
          {title}
          {subTitle ? <p className={styles['table-title-sub-title']}>{subTitle}</p> : null}
        </h2>
      ) : null}
      <div className={styles['table-title-actions']}>
        {children}
      </div>
    </div>
  );
}

export default TableTitle;
